import PageLayer from "@Layouts/views/PageLayer";
import CallActivityLayer from "@/DataPages/components/CallActivity/components/CallActivityLayer";

// Icons
import CallActivityIcon from "@/assets/icons/dataPages/callActivity/CallActivity.svg";

export default function CallActivityReport() {
	return (
		<PageLayer title={"Call Activity Report"} icon={CallActivityIcon}>
			<CallActivityLayer />
		</PageLayer>
	);
}
